/* ==========================================================================
  cart.js only for cart page
========================================================================== */

"use strict";

/* global jQuery, $ */

jQuery(function ($) {
  // Sync coupon code input values
  $(".woocommerce").on("input", "#coupon_code_totals", function () {
    $("#coupon_code").val($(this).val());
  });

  // Sync apply coupon button click
  $(".woocommerce").on("click", "#apply_coupon_totals", function (e) {
    e.preventDefault();
    $("button[name='apply_coupon']").trigger("click");
  });

  $("#apply_coupon_totals").on("click", function (e) {});

  let timeout;

  // Update cart totals when quantity changes

  $(".woocommerce").on("change", "input.qty", function () {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function () {
      $("[name='update_cart']").trigger("click");
    }, 500);
  });
});
